module.exports = __webpack_public_path__ + "static/img/landmark.30f9b589.png";